import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { FeatureExposed } from "@/utils/feature-exposed";

import {
    FreeForTenUsersText,
    Headings,
    WelcomeBackText
} from "../../../components";

export const LoggedInJiraFreeExistingSitesUser = () => {
    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm">
                <div css={containerCss}>
                    <Headings
                        main={<WelcomeBackText />}
                        sub={<FreeForTenUsersText />}
                    />
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
